import React from 'react';
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';
import { FaGlobe, FaUsers, FaAward, FaHandshake, FaChartLine, FaShieldAlt, FaLightbulb, FaRocket } from 'react-icons/fa';

const About = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="hero-section">
        <Container>
          <Row className="align-items-center">
            <Col lg={8}>
              <h1 className="display-4 fw-bold mb-4">About NIKDIP Multinational</h1>
              <p className="lead mb-4">
                Your trusted partner in industrial water treatment solutions, delivering excellence 
                across Africa and global markets since 2024.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Story */}
      <section className="section-padding">
        <Container>
          <Row className="mb-5">
            <Col lg={12} className="text-center mb-5">
              <h2 className="display-5 fw-bold">Our Story</h2>
            </Col>
          </Row>
          <Row>
            <Col lg={10} className="mx-auto">
              <p className="lead text-center mb-4">
                Founded with a vision to revolutionize industrial water treatment in Africa, 
                NIKDIP Multinational has grown into a trusted name in water treatment solutions.
              </p>
              <p className="text-center">
                We combine cutting-edge technology, deep industry expertise, and unwavering commitment 
                to deliver solutions that protect your assets, optimize performance, and ensure regulatory compliance.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Core Values */}
      <section className="section-padding bg-light">
        <Container>
          <Row className="mb-5">
            <Col lg={12} className="text-center mb-5">
              <h2 className="display-5 fw-bold">Our Core Values</h2>
            </Col>
          </Row>
          <Row>
            <Col lg={3} md={6} className="mb-4">
              <Card className="h-100 text-center value-card">
                <Card.Body className="p-4">
                  <div className="value-icon mb-3">
                    <FaShieldAlt className="text-primary" />
                  </div>
                  <Card.Title as="h4">Integrity</Card.Title>
                  <Card.Text>
                    We operate with transparency and honesty in all our business dealings.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6} className="mb-4">
              <Card className="h-100 text-center value-card">
                <Card.Body className="p-4">
                  <div className="value-icon mb-3">
                    <FaLightbulb className="text-warning" />
                  </div>
                  <Card.Title as="h4">Innovation</Card.Title>
                  <Card.Text>
                    Continuously developing new solutions to meet evolving industry challenges.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6} className="mb-4">
              <Card className="h-100 text-center value-card">
                <Card.Body className="p-4">
                  <div className="value-icon mb-3">
                    <FaUsers className="text-success" />
                  </div>
                  <Card.Title as="h4">Customer Focus</Card.Title>
                  <Card.Text>
                    Your success is our priority. We build lasting partnerships with our clients.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6} className="mb-4">
              <Card className="h-100 text-center value-card">
                <Card.Body className="p-4">
                  <div className="value-icon mb-3">
                    <FaRocket className="text-danger" />
                  </div>
                  <Card.Title as="h4">Excellence</Card.Title>
                  <Card.Text>
                    We deliver superior quality and service in everything we do.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Expertise */}
      <section className="section-padding">
        <Container>
          <Row className="mb-5">
            <Col lg={12} className="text-center mb-5">
              <h2 className="display-5 fw-bold">Our Expertise</h2>
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={6} className="mb-4">
              <Card className="h-100 expertise-card">
                <Card.Body className="p-4">
                  <Badge bg="primary" className="mb-3">Technical Excellence</Badge>
                  <Card.Title as="h4">Industry Leadership</Card.Title>
                  <Card.Text>
                    <ul>
                      <li>15+ years combined experience in water treatment</li>
                      <li>Certified water treatment specialists</li>
                      <li>Continuous research and development</li>
                      <li>Partnerships with leading chemical manufacturers</li>
                    </ul>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <Card className="h-100 expertise-card">
                <Card.Body className="p-4">
                  <Badge bg="success" className="mb-3">Global Reach</Badge>
                  <Card.Title as="h4">Market Presence</Card.Title>
                  <Card.Text>
                    <ul>
                      <li>Headquartered in Lagos, Nigeria</li>
                      <li>Serving clients across West Africa</li>
                      <li>Expanding operations in East Africa</li>
                      <li>Global supply chain partnerships</li>
                    </ul>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <Card className="h-100 expertise-card">
                <Card.Body className="p-4">
                  <Badge bg="warning" className="mb-3">Quality Assurance</Badge>
                  <Card.Title as="h4">Certifications</Card.Title>
                  <Card.Text>
                    <ul>
                      <li>ISO 9001:2015 Quality Management</li>
                      <li>Environmental compliance certifications</li>
                      <li>Safety management systems</li>
                      <li>Industry best practices adherence</li>
                    </ul>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Why Choose Us */}
      <section className="section-padding bg-light">
        <Container>
          <Row className="mb-5">
            <Col lg={12} className="text-center mb-5">
              <h2 className="display-5 fw-bold">Why Choose NIKDIP?</h2>
            </Col>
          </Row>
          <Row>
            <Col lg={6} className="mb-4">
              <div className="d-flex mb-3">
                <FaHandshake className="text-primary me-3 mt-1" />
                <div>
                  <h5>Trusted Partnership</h5>
                  <p>We build long-term relationships based on trust, reliability, and mutual success.</p>
                </div>
              </div>
              <div className="d-flex mb-3">
                <FaChartLine className="text-success me-3 mt-1" />
                <div>
                  <h5>Proven Results</h5>
                  <p>Track record of delivering measurable improvements in system efficiency and cost savings.</p>
                </div>
              </div>
            </Col>
            <Col lg={6} className="mb-4">
              <div className="d-flex mb-3">
                <FaGlobe className="text-info me-3 mt-1" />
                <div>
                  <h5>Local Expertise, Global Standards</h5>
                  <p>Understanding of local challenges with international best practices.</p>
                </div>
              </div>
              <div className="d-flex mb-3">
                <FaAward className="text-warning me-3 mt-1" />
                <div>
                  <h5>Industry Recognition</h5>
                  <p>Acknowledged leader in industrial water treatment solutions across Africa.</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Call to Action */}
      <section className="section-padding bg-primary text-white">
        <Container>
          <Row className="text-center">
            <Col lg={8} className="mx-auto">
              <h2 className="display-5 fw-bold mb-4">Ready to Partner With Us?</h2>
              <p className="lead mb-4">
                Join hundreds of satisfied clients who trust NIKDIP for their water treatment needs.
              </p>
              <div className="d-flex gap-3 justify-content-center">
                <a href="/contact" className="btn btn-light btn-lg">Get Started</a>
                <a href="/services" className="btn btn-outline-light btn-lg">Our Services</a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default About;
